<div class="card block isMinimizable"
     [stepContent]="achatStepContent"
     joyrideStep="achatStep">
    <div class="card-header">
        <div class="card-title">
            <h6>Total projet
                <p class="value">{{ favorite.total_price | number: '1.0-0' }} €</p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Achat</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_achat.PNG" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <div class="col-md-6">
                <mat-form-field>
                    <mat-label>Prix d'achat FAI<i class="fa fa-info-circle" matTooltip="Indiquez ici le montant de votre offre d’achat, frais d’agence inclus (FAI)"></i></mat-label>
                    <input type="number" step="1000" matInput [(ngModel)]="favorite.price" (ngModelChange)="edit($event, 'price')">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>

            <div class="col-6 col-md-6">
                <mat-form-field>
                    <mat-label>Prix Mobiliers / Électroménager</mat-label>
                    <input type="number" step="500" matInput [(ngModel)]="favorite.furniture_price" (ngModelChange)="edit($event)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>

            <div class="col-6 col-md-4">
                <mat-form-field>
                    <mat-label>Frais de notaire<i class="fa fa-info-circle" matTooltip="Environ 8% dans l’ancien et 2,5% dans le neuf."></i></mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.notary_price" (ngModelChange)="edit($event)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div class="col-6 col-md-4">
                <mat-form-field>
                    <mat-label>Frais d'agence</mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.agency_fees" (ngModelChange)="edit($event)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div class="col-6 col-md-4">
                <mat-form-field>
                    <mat-label *ngIf="user.pro_plan == ''">Autres frais<i class="fa fa-info-circle" matTooltip="Renseignez ici la liste des autres frais liés à cet achat : Chasseur immobilier, architecte, maître d’œuvre, géomètre ..."></i></mat-label>
                    <mat-label *ngIf="user.pro_plan != ''">Frais de chasse</mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.other_fees" (ngModelChange)="edit($event)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>


        </div>
    </div>
</div>

<ng-template #achatStepContent>
    <div class="user_onboarding_content">
        <h2>Les chiffres de votre achat</h2>
        <p>
            Dans ce cadre, vous devez renseigner tous les <b>chiffres de votre achat</b> : le prix, les différents frais, et
            même les travaux.<br/>
            <br/>
            En haut à droite, vous aurez le coût total de votre projet, essentiel pour calculer votre <b>rendement locatif</b>
            !
        </p>
    </div>
</ng-template>
